import React, { Component } from "react";
import TrimbleMaps from "@trimblemaps/trimblemaps-js";
import MapHelper from "../utils/helper";
import "../styles/mapStyles.scss";
import "@trimblemaps/trimblemaps-js/trimblemaps.css";
import isEqual from "lodash/isEqual"
import {MapContext} from "./MapContext"

class Map extends Component {
  map = null;
  constructor(props) {
    super(props);
    this.state = {
      mapLoaded: false,
      isStyleLoaded: false,
    };
  }

  componentDidMount() {
    this.props.eventHub && this.props.eventHub.on("mapResize", this.mapResize);
    this.props.mapConfig && this.initializeMap();
  }

  shouldComponentUpdate(nextProps, nextState){
    return !(isEqual(this.props, nextProps) && isEqual(this.state, nextState))
  }

  initializeMap = () => {
    MapHelper.setConfig({
      ...this.props.mapConfig.trimble,
      enableTrafficWeatherLayer: this.props.mapConfig.enableTrafficWeatherLayer
    });
    TrimbleMaps.APIKey = MapHelper.getKey();
    const style = this.props.satteliteView ? "satellite" : this.props.mapTheme;

    if(this.map){
      this.map.remove();
    }

    this.map = new TrimbleMaps.Map({
      container: this.props.mapId,
      center: this.props.center,
      zoom: this.props.zoom,
      style: MapHelper.getMapStyle(style),
      preserveDrawingBuffer: Boolean(this.props.enablePrint), // required for printing the map
    });

    this.map?.on("load", () => {
      if (
        this.props.trafficWeatherVisibility &&
        this.props.mapConfig.enableTrafficWeatherLayer
      ) {
        this.map.setTrafficVisibility(true);
        this.map.setWeatherAlertVisibility(true);
      }

      this.props.eventHub?.emit(`set_${this.props.mapId}`, this.map);

      this.setState(
        {
          mapLoaded: true,
        },
        () => {
          this.map?.on("click", this.onMapClicked);
          this.map?.on("styledata", this.onStyleLoaded);
        }
      );
    });
  };

  mapResize = () => {
    // TODO : find a better way to handle map resizing when container is resized.
    setTimeout(() => {
      this.map?.resize();
    }, 0);
  };

  componentWillUnmount() {
    this.props.eventHub && this.props.eventHub.off("mapResize", this.mapResize);
    if (this.map) {
      this.map?.off("click", this.onMapClicked);
      this.map?.off("styledata", this.onStyleLoaded);
      this.map.remove();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.mapConfig !== prevProps.mapConfig && this.props.mapConfig) {
      this.initializeMap();
    }
    if (this.props.mapTheme !== prevProps.mapTheme) {
      this.setState({
        isStyleLoaded: false,
      });
      this.map?.setStyle(MapHelper.getMapStyle(this.props.mapTheme));
    }
  }

    onStyleLoaded = () => {
        this.setState({
            isStyleLoaded: true
        });
        this.map?.setCenter(this.map?.getCenter());
        if (this.props.getMapStyleName) {
            this.props.getMapStyleName(this.map?.getStyle().name);
        }
    }

  onMapClicked = (event) => {
    if (this.props.onClick) {
      this.props.onClick(event.lngLat);
    }
  };

  render() {
        return (
          <div
            id={this.props.mapId}
            className={`mapContainer theme-${this.props.mapTheme || "light"}`}
          >
            {this.map && (
              <MapContext.Provider
                value={{
                  map: this.map,
                  mapCenter: this.props.center,
                  theme: this.props.mapTheme,
                  isStyleLoaded: this.state.isStyleLoaded,
                  isDefaultSattelite: this.props.satteliteView,
                  mapId: this.props.mapId,
                }}
              >
                {this.props.children}
              </MapContext.Provider>
            )}

            <div id="metrics-container">
              <div id="distance"></div>
              <div id="travelTime"></div>
            </div>
          </div>
        );
    }
}

export default Map;
